var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("Error: Server Side Error")]),_vm._m(0),_c('p',[_c('router-link',{attrs:{"to":`/${_vm.lang}/`}},[_vm._v("トップに戻る")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(" サーバ側で問題が発生しました。"),_c('br'),_vm._v(" 時間を空けてから再度アクセスをお願いします。 ")])
}]

export { render, staticRenderFns }